import { FixbotCTA } from '@ifixit/fixbot/fixbot-cta';
import initializeComponent from 'Shared/react-initialize';

function AnswersFixbotCTACard({
   questionId,
   fixbotOrigin,
}: {
   questionId: number;
   fixbotOrigin: string;
}) {
   return (
      <div>
         <FixbotCTA
            origin={fixbotOrigin}
            contentType="question"
            contentId={questionId}
            analyticsCategory="Answers"
            translationNamespace="FixbotCTAAnswers"
            variant="button"
         />
      </div>
   );
}

initializeComponent('AnswersFixbotCTACard', AnswersFixbotCTACard);
